
<template>
  <v-app  id="app">


    <v-card flat dark style="width: 100%; height: 100%">


      <v-btn @click="processPaymentBronze">ADD ORDER</v-btn>

      <v-btn  @click="startIt">Start IT</v-btn>

      <v-btn @click="stopIt">StOP IT</v-btn>





      <v-btn @click="getDailyStats"  color="red">NEW</v-btn>




      <div style="padding-top: 10%">

        <v-card light style="width: 60%; height: 50%; margin-left: auto; margin-right: auto">


          <div style="width: 100%; height: 15%; display: flex; justify-content: center; align-items: center; font-size: 1.5vw; font-weight: bold; color: rgba(0,0,0,0.6)">

            {{testExit}}


          </div>




        </v-card>





      </div>








    </v-card>




  </v-app>
</template>

<script>

  import Vue from 'vue'
  import Vuetify from 'vuetify'
  import 'vuetify/dist/vuetify.min.css'
  import { AXIOS } from '../../http-common'

  import VueCookies from 'vue-cookies'

  Vue.use(Vuetify)
  Vue.use(VueCookies)

  export default {

    data () {
      return {


        dialyStatsRepsone: [],

        // testDate: 1583313499,

        testDate: new Date(1583313499).toLocaleTimeString(),

        testArtis:'',


        // 1583247645


        badgeStuff: '',

        njam: false,

        numberToSend: '',
        mask1: '##############',
        value1: '',

        selectiveResponse: '',
        responseTimeResponse: '',

        theK: '',

        clickedHoe: '',

        location: null,
        gettingLocation: false,
        errorStr: null,

        creditOne: 0.67,
        youPay: '',
        youWillGet: '',

        bundlePaymentAmount: '',
        creditsForAmountGiven: '',

        offerCredits: '',

        freeCreditsYouWillReceive: '',

        fruitSelectIcon: ' fas fa-check',
        favouriteFruit: '',
        show: null,

        testExit: '',
      }
    },

    watch: {



    },

    created () {

      this.convertDate();
      this.getDays();
      this.playWithDates()

    },

    computed: {



    },
    methods: {


      playWithDates() {

        var currentDate = new Date().toJSON().substr(0,10)
        var currentTime = new Date().toTimeString().substr(0,8)

        this.testExit = currentDate + "T" + currentTime

      },


      getDays() {

        var currentYear = new Date().getFullYear()
        var currentMonth = new Date().getMonth() + 1

        var hh = new Date(currentYear, currentMonth, 0).getDate();

      },


      convertDate(){


        this.testArtis = new Date(1583247645 * 1000);
        // console.log(date.toUTCString())


      },





      getDailyStats(){

        AXIOS({
          method: 'GET',
          url: '/api/orders/stats/orders/perday/2',
          headers: {
            Authorization: 'Bearer ' + window.$cookies.get('session'),
            'Access-Control-Allow-Origin': '*'
          }
        }).then(response => {
          // console.log(response.data)

        })



      },

      convertNumber () {
        if (this.value1.startsWith(0)) {
          this.editNumber = this.value1.substr(1, 12)

          this.numberToSend = '44' + this.editNumber
        } else {
          this.numberToSend = 'Does not start with 0'
        }
      },




      notificationsForOrders () {
        Notification.requestPermission().then(function (result) {
          if (result === 'denied') {
            // console.log('Permission wasn\'t granted. Allow a retry.');
            return
          }
          if (result === 'default') {
            // console.log('The permission request was dismissed.');

          }
          // Do something with the granted permission.
        })
      },



      startIt () {
        this.every30 = setInterval(this.processPaymentBronze, 10000)
      },

      stopIt () {
        clearInterval(this.every30)
      },



      processPaymentBronze: function () {
        function makeid (length) {
          var result = ''
          var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
          var charactersLength = characters.length
          for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength))
          }
          return result
        }

        function makenumber (length) {
          var result = '07'
          var characters = '0123456789'
          var charactersLength = characters.length
          for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength))
          }
          return result
        }

        function makeAmount (length) {
          var result = ''
          var characters = '123456789'
          var charactersLength = characters.length
          for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength))
          }
          return result
        }

        AXIOS({
          method: 'POST',
          url: 'api/order/',
          data: {
            serviceId: 1,
            telephoneNumber: makenumber(10),
            amount: makeAmount(2),
            credit: 1000,
            creditProcessed: 0,
            customerPayPalId: 'TEST',
            paymentCurrency: 'GBP',
            payPalCaptureTime: null,
            transactionId: makeid(12),
            orderNumber: '444',
            processTime: null,
            refund: false
          }
        })
                .then(response => {
                  // console.log(response)


                  // this.editPURCHASE(response);
                  // setTimeout(() => this.editPURCHASE(response), 500)
                  //
                  //







                })


      },

      editPURCHASE(i){

        AXIOS({
          method: 'POST',
          url: '/api/order',
          data: {
            id: i.data.id,
            serviceId: Math.floor(Math.random() * 3) + 1,
            telephoneNumber: i.data.telephoneNumber,
            amount: i.data.amount,
            credit: 1000,
            creditProcessed: 0,
            customerPayPalId: 'TEST',
            paymentCurrency: 'GBP',
            payPalCaptureTime: null,
            transactionId: i.data.transactionId,
            orderNumber: '444',
            created:"2020-05-25T" + Math.floor(Math.random() * 23) + 1   +":05:58.636",
            processTime: null,
            refund: false
          },
          headers: {
            Authorization: 'Bearer ' + window.$cookies.get('session'),  'Access-Control-Allow-Origin': '*'
          }
        })
                .then(response => {
                  // console.log(response)
                })

      }
    }




  }
</script>

<style >

  #app {
    margin: 0;
    height: 100%;
    width: 100%;

  }



</style>
